var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "sales-note",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline is-centered" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("VoucherDetails", {
              attrs: {
                disabled: _vm.isLoading || _vm.stamped,
                "is-loading": _vm.isLoading
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            !_vm.isLoading
              ? _c("Concepts", {
                  attrs: {
                    "is-loading": _vm.isLoading,
                    disabled: _vm.isLoading || _vm.stamped
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _vm.stamped || _vm.canceled
            ? _c("div", { staticClass: "field is-grouped" }, [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: { name: "SaleNoteList" }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "field is-grouped" }, [
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.isLoading },
                        attrs: {
                          disabled: _vm.isLoading,
                          to: { name: "SaleNoteList" }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }